import { Expose } from "class-transformer";

export interface IAirBundleSubscription {
  airPayoutCreditsLeft: number;
  airLuggageCreditsLeft: number;
  airPayoutUnlimitedAccess: boolean;
  airLuggageUnlimitedAccess: boolean;
}

export class AirBundleSubscription implements IAirBundleSubscription {
  @Expose() airPayoutCreditsLeft: number;
  @Expose() airLuggageCreditsLeft: number;
  @Expose() airPayoutUnlimitedAccess: boolean;
  @Expose() airLuggageUnlimitedAccess: boolean;

  @Expose()
  get hasCredit(): boolean {
    return !!(this.airPayoutCreditsLeft > 0 || this.airLuggageCreditsLeft > 0);
  }

  @Expose()
  get airLuggageAccess(): boolean {
    return !!(this.airLuggageUnlimitedAccess || this.airLuggageCreditsLeft > 0);
  }
}
